import { useRouteError, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { AlertCircle } from 'lucide-react'

export function RouteErrorFallback() {
  const error = useRouteError()
  const navigate = useNavigate()

  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'object' && error !== null && 'statusText' in error
        ? String((error as { statusText: string }).statusText)
        : 'An unexpected error occurred'

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[hsl(var(--background))] text-center px-4">
      <div className="h-16 w-16 rounded-full bg-[hsl(var(--muted))] flex items-center justify-center mb-4">
        <AlertCircle className="h-8 w-8 text-[hsl(var(--muted-foreground))]" />
      </div>
      <h1 className="text-lg font-semibold mb-1">Something went wrong</h1>
      <p className="text-sm text-[hsl(var(--muted-foreground))] mb-4 max-w-sm">
        {message}
      </p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => void navigate('/app/bids')}>
          Go to Bids
        </Button>
        <Button onClick={() => window.location.reload()}>
          Try Again
        </Button>
      </div>
      {import.meta.env.DEV && error instanceof Error && error.stack && (
        <pre className="mt-6 text-left text-xs text-[hsl(var(--destructive))] bg-[hsl(var(--muted))] p-4 rounded-lg max-w-lg overflow-auto max-h-48">
          {error.stack}
        </pre>
      )}
    </div>
  )
}
